import { Skeleton, SkeletonRegion } from "@/components/ui/skeleton";
import CardSkeleton from "@/components/skeletons/CardSkeleton";

export default function BudgetPageSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <div className="rounded-2xl bg-card border border-border p-4 sm:p-6 shadow-card space-y-4">
        <Skeleton className="h-4 w-1/4" />
        <Skeleton className="h-8 w-40" />
        <Skeleton className="h-2 w-full rounded-full" />
      </div>
      <CardSkeleton lines={2} />
      <div className="rounded-2xl bg-card border border-border p-4 sm:p-6 shadow-card space-y-3">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-9 flex-1 rounded-lg" />
          </div>
        ))}
      </div>
    </SkeletonRegion>
  );
}
